import React, { FC } from 'react';
import { Typography } from 'antd';

import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import constants from '~/utils/constants';
import { languagesConfig } from '~/utils/i18n';

type StoreType = 'google' | 'apple';

interface Props {
  type: StoreType;
}

const ApplicationStoreLink: FC<Props> = (props) => {
  const { type } = props;
  const { i18n } = useTranslation();
  const language = i18n.language;

  const href =
    type === 'google'
      ? constants?.resetPasswordGooglePlayLink
      : type === 'apple'
      ? constants?.resetPasswordAppStoreLink
      : undefined;

  const icon = getIcon(type, language);
  if (!icon) return null;
  return (
    <StyledLink role="button" href={href} target="_blank">
      <icon.type className="StoreIcon" />
    </StyledLink>
  );
};

const getIcon = (type: StoreType, lang: string) => {
  if (type === 'google') {
    return languagesConfig[lang].googlePlayIcon;
  } else if (type === 'apple') {
    return languagesConfig[lang].appStoreIcon;
  } else {
    return null;
  }
};

const StyledLink = styled(Typography.Link)`
  .StoreIcon {
    font-size: 158px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
    align-items: center;
    max-width: 135px;
    height: 40px;
    @media (max-width: 400px) {
      height: 35px;
    }
  }
`;

export default ApplicationStoreLink;
